<style lang="less"></style>

<template>
    <MenuList sidebarClassName="export-menu-item" :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";

    declare var WordExport: any;
    declare var PPTExport: any;
    declare var XLExport: any;
    declare var HtmlExport: any;
    declare var saveAs: any;

    @Component({
        components: {
            MenuList,
        },
    })
    export default class DownloadMenus extends Vue {
        tempDisable = !appConfig.isBuild;
        pollingCount: number = 0;
        fileName: string = "";
        lock = false;
        @Inject()
        ["checkVipLimit"];
        get menuList() {
            let list = [
                { key: "outputImg", img: require("@/app/assets/img/export/img.svg") },
                { key: "outputPdf", img: require("@/app/assets/img/export/pdf.svg") },
                { key: "outputWord", img: require("@/app/assets/img/export/word.svg") },
                { key: "outputExcel", img: require("@/app/assets/img/export/excel.svg") },
                { key: "outputPPT", img: require("@/app/assets/img/export/ppt.svg") },
                { key: "outputSVG", img: require("@/app/assets/img/export/svg.svg") },
                { key: "outputHTML", img: require("@/app/assets/img/export/html.svg") },
                {
                    key: "outputVisio",
                    img: require("@/app/assets/img/export/visio.svg"),
                    isRender: !this.isWorkwx,
                    showVip: !this.vip,
                },
                { key: "outputEddx", img: require("@/app/assets/topPanel/logo.svg"), bigLogo: true },
                { key: "GoogleSlide", isRender: false && this.googleSlide },
            ];
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t("DownloadMenus." + item.key) }));
            });
            return { list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "outputImg",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportImage")) {
                            this.closeDrop();
                            return;
                        }
                        this.outputImg();
                    },
                ],
                [
                    "outputPdf",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportPdf")) {
                            this.closeDrop();
                            return;
                        }
                        this.exportDoc("PDF");
                    },
                ],
                [
                    "outputVisio",
                    () => {
                        event.stopPropagation();
                        this.exportDoc("Visio");
                    },
                ],
                [
                    "outputWord",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportWord")) {
                            this.closeDrop();
                            return;
                        }
                        this.exportDoc("Word");
                    },
                ],
                [
                    "outputPPT",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportPpt")) {
                            this.closeDrop();
                            return;
                        }
                        this.exportDoc("PowerPoint");
                    },
                ],
                [
                    "outputExcel",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportExcel")) {
                            this.closeDrop();
                            return;
                        }
                        this.exportDoc("Excel");
                    },
                ],
                [
                    "outputHTML",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportHtml")) {
                            this.closeDrop();
                            return;
                        }
                        this.exportDoc("Html");
                    },
                ],
                [
                    "outputEddx",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportEddx")) {
                            this.closeDrop();
                            return;
                        }
                        window["_view"].saveFileToLocal();
                        this.closeDrop();
                    },
                ],
                [
                    "outputSVG",
                    () => {
                        event.stopPropagation();
                        if (this.checkVipLimit("exportSvg")) {
                            this.closeDrop();
                            return;
                        }
                        this.exportDoc("Svg");
                    },
                ],
                [
                    "GoogleSlide",
                    () => {
                        event.stopPropagation();
                        this.exportDoc("GoogleSlide");
                    },
                ],
            ]);
            if (this.lock) return;

            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        get googleSlide() {
            return appConfig.language != "zh";
        }
        get showVipChoseDialog() {
            return this.$store.state.ui.showVipChoseDialog;
        }
        set showVipChoseDialog(v) {
            this.$store.commit("setStatus", {
                type: "showVipChoseDialog",
                data: v,
            });
        }
        get vipNextAction() {
            return this.$store.state.ui.vipNextAction;
        }
        set vipNextAction(v) {
            this.$store.commit("setStatus", {
                type: "vipNextAction",
                data: v,
            });
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get exportLoadedStatus() {
            return this.$store.state.ui.exportLoadedStatus;
        }
        set exportLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "exportLoadedStatus",
                data: v,
            });
        }
        outputImg() {
            // 显示导出图片弹窗
            this.$track("menu", "file", "output data img");
            this.showOutImgDialog();
            this.$bus.$emit("showPublishGuide");
            this.$bus.$emit("changeUserTaskStatus", {
                id: 3,
                status: 1,
            }); // 新手任务
            this.closeDrop();
        }
        showUpgrade() {
            this.$checkAuth({ type: "output" });
        }
        showOutImgDialog() {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ouputImg",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            let view = window["_view"];
            if (view) {
                let data = view.exportImageInf();
                data &&
                    this.$store.commit("setStatus", {
                        type: "exportImageInfo",
                        data: data,
                    });
            }
            this.closeDrop();
        }
        showOutDialog(dialogType: string, type: string) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: dialogType,
            });
            this.$store.commit("setDialogState", {
                type: "exportType",
                data: type,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        exportDoc(type: string) {
            let ts: any = this;
            // if (type != "PDF" && !ts.$checkAuth({ type: "output" })) {
            //     this.closeDrop();
            //     return;
            // }
            let view = window["_view"];
            this.$track("menu", "file", "output data " + type);
            this.$store.commit("setState", {
                type: "is_export_file",
                data: "exportFile",
            });
            let saveToInclowdz = (data) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: data.name,
                                filesize: data.size,
                                base64_data: (<any>e.target).result,
                            },
                        },
                        "*"
                    );
                };
                reader.readAsDataURL(data.blob);
            };
            switch (type) {
                case "Word":
                case "PowerPoint":
                case "Excel":
                    this.showOutDialog("ouputPPTExcelWord", type);
                    break;
                case "Visio":
                    this.$pcTrack("saveFileProcess_pickAnExportType", `fileType: visio`);
                    if (!this.vip) {
                        this.$openBuyPage("visio");
                        return;
                    }
                    this.lock = true;
                    let removeLoadingRes = this.$edMessage.loadingBar({
                        content: <string>this.$t("fileDownloading"),
                        duration: 0,
                    });
                    let timeStart = Date.now();
                    let timerId = setTimeout(() => {
                        removeLoadingRes.instance?.$refs?.progressBar?.pause();
                    }, 2000);

                    let pollingConvert = (u) => {
                        let params = {
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            u: u,
                        };
                        this.$edApi.getConvertResult(params).then((res) => {
                            let data = res.data;
                            if (data && data.url) {
                                this.$edApi
                                    .downloadConvertFile({ url: data.url })
                                    .then((e) => {
                                        let fileName = this.fileName.substr(0, this.fileName.length - 5) + ".vsdx";
                                        let convertedFile = new File([e.data], fileName);
                                        const time = Date.now() - timeStart;
                                        if (time < 2000) {
                                            clearTimeout(timerId);
                                            removeLoadingRes.instance?.$refs?.progressBar?.finish();
                                        } else {
                                            removeLoadingRes.instance?.$refs?.progressBar?.resume();
                                        }
                                        removeLoadingRes.remove();
                                        if (this.isInclowdz) {
                                            saveToInclowdz({
                                                blob: e.data,
                                                name: fileName,
                                                size: e.data.size,
                                            });
                                        } else {
                                            saveAs(convertedFile);
                                            this.sensors.track("exportSuccess", {
                                                Catalogues: "saveFileProcess",
                                                savesource: "exportSave",
                                                file_type: "visio",
                                                export_order: 1,
                                            });
                                        }
                                    })
                                    .finally(() => {
                                        this.lock = false;
                                    });
                            } else {
                                if (this.pollingCount > 240) {
                                    this.$edMessage.error(this.$t("limitTime"));
                                    this.lock = false;
                                    return;
                                }
                                this.pollingCount++;
                                setTimeout(() => {
                                    pollingConvert(u);
                                }, 500);
                            }
                        });
                    };
                    view.zipFile()
                        .then((e) => {
                            let params = {
                                id: this.userInfo.user_id,
                                token: this.userInfo.token,
                                file: new File([e[0]], e[1]),
                                to: "vsdx",
                            };
                            this.fileName = e[1];

                            if (window.EDCONFIG.IS_SDK) {
                                this.sdkApp.promisePostMessage("EXPORT_VISIO_FILE", { to: params.to, file: params.file }).finally(() => {
                                    removeLoadingRes.remove();
                                    this.lock = false;
                                });
                                return;
                            }

                            this.$edApi
                                .exportVisioFile(params)
                                .then((e) => {
                                    let u = e.u;
                                    pollingConvert(u);
                                })
                                .catch((e) => {
                                    removeLoadingRes.remove();
                                    this.lock = false;
                                });
                        })
                        .catch((e) => {
                            removeLoadingRes.remove();
                            this.lock = false;
                        });
                    this.sensors.track("pickAnExportType", {
                        Catalogues: "saveFileProcess",
                        savesource: "exportSave",
                        file_type: "visio",
                    });
                    break;

                case "Svg":
                    this.showOutDialog("ouputSvg", type);
                    break;

                case "PDF":
                    this.showOutDialog("ouputPDF", type);
                    break;

                case "Html":
                    this.showOutDialog("ouputHTML", type);
                    break;

                case "GoogleSlide":
                    this.slide();
                    break;

                default:
                    break;
            }

            this.$bus.$emit("changeUserTaskStatus", {
                id: 3,
                status: 1,
            }); // 新手任务

            this.$bus.$emit("showPublishGuide");
            this.closeDrop();
        }
        exportOffice(type: string) {
            let ts: any = this;
            // if (type != "PDF" && !ts.$checkAuth({ type: "output" })) return;
            if (!this.exportLoadedStatus) {
                this.exportLoadedStatus = 1;
                this.$store.dispatch("loadConfig", ["ExpXml4Office.tar"]).then((e) => {
                    this.exportLoadedStatus = 2;
                    this.exportDoc(type);
                });
            } else if (this.exportLoadedStatus == 2) {
                this.exportDoc(type);
            }
        }

        // google slide
        slide() {
            let ts: any = this;
            ts.$bus.$emit("outputGoogleSlide", 1);
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "DownloadMenus": {
      "outputImg": "图片（PNG/JPG...）",
      "outputPdf": "PDF",
      "outputVisio": "Visio",
      "outputWord": "Word",
      "outputPPT": "PPT",
      "outputExcel": "Excel",
      "outputHTML": "HTML",
      "outputSVG": "无损SVG",
      "GoogleSlide": "Google Slide",
      "outputEddx": "EdrawMax"
    },
    "limitTime": "请求超时，请重试",
    "fileDownloading": "正在导出，请稍后..."
  },
  "en": {
    "DownloadMenus": {
      "outputImg": "Export Image",
      "outputPdf": "Export PDF",
      "outputVisio": "Export Visio (.vsdx)",
      "outputWord": "Export Word (.docx)",
      "outputPPT": "Export PowerPoint (.pptx)",
      "outputExcel": "Export Excel (.xlsx)",
      "outputHTML": "Export Html",
      "outputSVG": "Export SVG",
      "GoogleSlide": "Google Slide",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "Time out, please retry",
    "fileDownloading": "Exporting your file, please waiting..."
  },
  "fr": {
    "DownloadMenus": {
      "outputImg": "Exporter des graphiques",
      "outputPdf": "Exporter PDF",
      "outputVisio": "Exporter Visio (.vsdx)",
      "outputWord": "Exporter Word (.docx)",
      "outputPPT": "Exporter PowerPoint (.pptx)",
      "outputExcel": "Exporter Excel (.xlsx)",
      "outputHTML": "Exporter HTML",
      "outputSVG": "Exporter SVG",
      "GoogleSlide": "Google Diaporama",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "\nQǐngqiú chāoshí, qǐng chóng shì\n8/5000\nDemande a expiré, veuillez réessayer",
    "fileDownloading": "Exportation de votre fichier, veuillez patienter…"
  },
  "de": {
    "DownloadMenus": {
      "outputImg": "Grafiken exportieren",
      "outputPdf": "PDF exportieren",
      "outputVisio": "Visio exportien (.vsdx)",
      "outputWord": "Word exportieren (.docx)",
      "outputPPT": "PowerPoint exportieren (.pptx)",
      "outputExcel": "Excel exportieren (.xlsx)",
      "outputHTML": "Html exportieren",
      "outputSVG": "SVG exportieren",
      "GoogleSlide": "Google Slide",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "Auszeit, bitte versuchen Sie es erneut",
    "fileDownloading": "Datei wird exportiert, bitte warten ..."
  },
  "jp": {
    "DownloadMenus": {
      "outputImg": "画像にエクスポート",
      "outputPdf": "PDFにエクスポート",
      "outputVisio": "Visio(vsdx)にエクスポート",
      "outputWord": "Word(docx)にエクスポート",
      "outputPPT": "PowerPoint(pptx)にエクスポート",
      "outputExcel": "Excel(xlsx)にエクスポート",
      "outputHTML": "HTMLにエクスポート",
      "outputSVG": "SVGにエクスポート",
      "GoogleSlide": "Googleスライド",
      "outputEddx": "EdrawMax (eddx)"
    },
    "limitTime": "リクエストがタイムアウトしました。もう一度お試しください",
    "fileDownloading": "ファイルのエクスポート中。お待ちください..."
  },
  "es": {
    "DownloadMenus": {
      "outputImg": "Gráficos de exportación",
      "outputPdf": "Exportar PDF",
      "outputVisio": "Exportar Visio (.vsdx)",
      "outputWord": "Exportar palabra (.docx)",
      "outputPPT": "Exportar PowerPoint (.pptx)",
      "outputExcel": "Exportar Excel (.xlsx)",
      "outputHTML": "Exportar Html",
      "outputSVG": "Exportar SVG",
      "GoogleSlide": "Diapositiva de Google",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "Se agotó el tiempo de espera de la operacion,inténtalo otra vez ",
    "fileDownloading": "Exportando el archivo, espera..."
  },
  "pt": {
    "DownloadMenus": {
      "outputImg": "Exportar Gráficos",
      "outputPdf": "Exportar PDF",
      "outputVisio": "Exportar Visio (.vsdx)",
      "outputWord": "Exportar Word (.docx)",
      "outputPPT": "Exportar PowerPoint (.pptx)",
      "outputExcel": "Exportar Excel (.xlsx)",
      "outputHTML": "Exportar Html",
      "outputSVG": "Exportar SVG",
      "GoogleSlide": "Google Slide",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "Fora do tempo，por favor tente novamente",
    "fileDownloading": "Exportando seu arquivo, aguarde..."
  },
  "it": {
    "DownloadMenus": {
      "outputImg": "Esporta in Immagine",
      "outputPdf": "Esporta in PDF",
      "outputVisio": "Esporta in Visio (.vsdx)",
      "outputWord": "Esporta in Word (.docx)",
      "outputPPT": "Esporta in PowerPoint (.pptx)",
      "outputExcel": "Esporta in Excel (.xlsx)",
      "outputHTML": "Esporta in HTML",
      "outputSVG": "Esporta in SVG",
      "GoogleSlide": "Presentazioni Google",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "Time out, per favore riprova",
    "fileDownloading": "Esportazione del file. Attendi..."
  },
  "tw": {
    "DownloadMenus": {
      "outputImg": "圖片",
      "outputPdf": "PDF",
      "outputVisio": "Visio(.vsdx)",
      "outputWord": "Word(.docx)",
      "outputPPT": "PowerPoint(.pptx)",
      "outputExcel": "Excel(.xlsx)",
      "outputHTML": "HTML",
      "outputSVG": "SVG",
      "GoogleSlide": "Google Slide",
      "outputEddx": "EdrawMax (.eddx)"
    },
    "limitTime": "請求超時，請重試",
    "fileDownloading": "正在匯出您的檔案，請稍候..."
  }
}
</i18n>
